export default __webpack_public_path__ + "static/media/lei-aldir-white.65982337.svg";